import React, { useEffect } from "react";
import Header from "../components/header/Header";
import MapSection from "../components/map";
import dataMap from "../assets/fakeData/dataMap";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import Contact from "../components/contact";

function ContactUs(props) {
  return (
    <>
      <Header />
      <MapSection markers={dataMap} />
      <Contact />
      <Footer />
      <Gotop />
    </>
  );
}

export default ContactUs;
